// types


// ==============================|| THEME CONSTANT  ||============================== //

import { DefaultConfigProps } from "./types/ConfigType";
import { NetworkMode } from '@tanstack/query-core/src/types';

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/dashboard';
export const HORIZONTAL_MAX_ITEM = 9; // Original 6
export const DRAWER_WIDTH = 260;

// ==============================|| THEME CONFIG  ||============================== //



const Config: DefaultConfigProps = {
    fontFamily: `'Inter', sans-serif`,
    i18n: 'en',
    menuOrientation: 'horizontal',
    miniDrawer: false,
    container: true,
    mode: 'light',
    presetColor: 'theme5',
    themeDirection: 'ltr'
};

const networkMode: NetworkMode = 'online';


export const DefaultUseQueryConfig = {
    enabled: true,  // Stops query from automatically running
    networkMode,
    retry: 3, // or false
    retryOnMount: false,
    retryDelay: attempt => attempt * 10000,
    //refetchInterval: false, Defaults to false,
    staleTime: 120000,
    refetchIntervalInBackground: false,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
}

export const DefaultUseQueryPaginateConfig = {
    enabled: true,  // Stops query from automatically running
    networkMode,
    retry: 1, // or false
    retryOnMount: false,
    retryDelay: attempt => attempt * 10000,
    //refetchInterval: false, Defaults to false,
    refetchIntervalInBackground: false,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    keepPreviousData: true, // For Pagination
    staleTime: Infinity,
}



export default Config;
